import { defineComponent, onBeforeUnmount, ref } from "vue";
import { GetFilesCommand } from "~/api/Common/Commands/GetFilesCommand";
import { FindFilesInfoResult } from "~/api/data/Common/FindFIlesInfoResult";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { FileCode } from "~/extensions/utils/DefineTypes";
import { FileHelper } from "~/extensions/utils/FileHelper";
import { api } from "../api";
import { MsgBox } from "./MsgBox";
import PdfViewer from "./PdfViewer.vue";
export default defineComponent({
    name: "FilePreview",
    emits: ["close"],
    components: {
        PdfViewer
    },
    props: {
        fileInfo: {
            type: Object,
            required: false
        },
        fileCode: {
            type: Number,
            required: false
        },
        targetNo: {
            type: String,
            required: false
        },
        result: {
            type: Object,
            required: false
        },
        fileList: {
            type: Object,
            required: false
        },
        index: {
            type: String,
            required: false
        },
        file: {
            type: File,
            required: false
        }
    },
    async setup(props, { emit }) {
        const showDialog = ref(true);
        const imageUrl = ref("");
        const blob = ref(null);
        const result = ref(new FindFilesInfoResult());
        const getFilesCommand = new GetFilesCommand();
        const fileName = ref("");
        const revokePreviewUrl = () => {
            if (imageUrl.value) {
                URL.revokeObjectURL(imageUrl.value);
                imageUrl.value = "";
            }
        };
        try {
            if (isNullOrUndefined(props.file)) {
                result.value = props.result ?? new FindFilesInfoResult();
                // ファイル取得パラメータ設定
                if (props.fileCode === FileCode.InformationFile) {
                    getFilesCommand.informationNo = Number(props.targetNo);
                }
                else if (props.fileCode === FileCode.TaikyoHasonFile || props.fileCode === FileCode.TaikyoOthersFile) {
                    getFilesCommand.OrgNyukyokeiyakuNo = Number(props.targetNo);
                }
                else {
                    getFilesCommand.shomeiNo = props.targetNo;
                }
                const fileNo = result.value.fileList.find(x => x.fileIdStr === props.index)?.fileNo;
                const fileExists = result.value.fileList.find(x => x.fileIdStr === props.index)?.fileExists;
                const fileFetchKb = props.fileInfo.fileList.find(x => x.fileCode === props.fileCode)?.fileFetchKb;
                getFilesCommand.fileList = [
                    {
                        fileNo: fileNo,
                        fileIdStr: props.index,
                        fileFetchKb: fileFetchKb,
                        fileCode: props.fileCode,
                        fileExists: fileExists
                    }
                ];
                // ファイル取得
                const res = await api.common.getFiles(getFilesCommand);
                const fileData = await FileHelper.getFirstFileFromZip(res);
                if (!fileData.blob) {
                    return;
                }
                if (!FileHelper.isPDF(fileData.fileName ?? "")) {
                    imageUrl.value = FileHelper.createObjectUrl(fileData.blob);
                }
                fileName.value = fileData.fileName;
                blob.value = fileData.blob;
            }
        }
        catch (ex) {
            MsgBox.error(ex?.message ?? "エラーが発生しました。");
        }
        // 閉じるボタン
        const closeDialog = () => {
            revokePreviewUrl();
            emit("close");
        };
        onBeforeUnmount(revokePreviewUrl);
        return {
            FileHelper,
            showDialog,
            fileName,
            imageUrl,
            blob,
            closeDialog,
            props,
            isNullOrUndefined
        };
    }
});
